import { Form, Input, Modal, ModalProps } from 'antd';
import FormField from 'components/FormField';
import { Formik } from 'formik';
import { useTranslate } from '@tolgee/react';
import { useEffect, useRef } from 'react';

const initialValues = {
  concept: '',
  example: '',
};

function ConceptForm({
  conceptList,
  onSave,
  onCancel,
  ...otherProps
}: ModalProps & {
  conceptList: (typeof initialValues)[];
  onSave: (concept: typeof initialValues) => void;
}) {
  const { t } = useTranslate();

  const inputRef = useRef<any>(null);

  useEffect(() => {
    if (otherProps.visible) {
      setTimeout(() => {
        inputRef.current.focus();
      }, 200);
    }
  }, [otherProps.visible]);

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={(values, { resetForm }) => {
        onSave(values);
        resetForm();
        onCancel?.({} as any);
        return Promise.resolve();
      }}
    >
      {({ isSubmitting, handleSubmit, resetForm }) => {
        return (
          <Modal
            title={t('自定义变量')}
            width={500}
            okText={t('保存')}
            okButtonProps={{
              loading: isSubmitting,
              onClick: () => handleSubmit(),
            }}
            onCancel={(e) => {
              onCancel?.(e);
              resetForm();
            }}
            {...otherProps}
          >
            <Form layout="vertical">
              <FormField<string>
                name="concept"
                required
                label={t('变量名称')}
                validate={(value) => {
                  if (!value.trim()) {
                    return t('department.请输入x', { x: t('变量名称') });
                  }
                  if (conceptList.some((concept) => concept.concept === value)) {
                    return t('x已存在', { x: t('变量名称') });
                  }
                }}
              >
                {({ field }) => {
                  return (
                    <Input
                      ref={inputRef}
                      showCount
                      maxLength={30}
                      placeholder={t('department.请输入x', { x: t('变量名称') })}
                      {...field}
                    />
                  );
                }}
              </FormField>
              <FormField<string>
                name="example"
                required
                label={t('示例内容')}
                validate={(value) => {
                  if (!value.trim()) {
                    return t('department.请输入x', { x: t('示例内容') });
                  }
                }}
              >
                {({ field }) => {
                  return (
                    <Input
                      showCount
                      maxLength={30}
                      placeholder={t('department.请输入x', { x: t('示例内容') })}
                      {...field}
                    />
                  );
                }}
              </FormField>
            </Form>
          </Modal>
        );
      }}
    </Formik>
  );
}

export default ConceptForm;
